<template>
  <div class="space-y-8">
    <SectionHeader :title="__('Privacy Settings')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="encrypted" is-filled />
      </template>
    </SectionHeader>

    <div class="shadow-card rounded-lg bg-white px-4 py-6 md:px-6 md:py-8">
      <form @submit.prevent="handleSubmit">
        <div class="space-y-4">
          <div class="grid grid-cols-4 md:grid-cols-4 items-center gap-4">
            <span class="col-span-3">{{ __('I agree to the') }}
              <a href="/terms-and-conditions-candidates" target="_blank" class="text-black underline">{{ __('terms and conditions') }}</a>
              {{ __(' and the ') }}
              <a href="/privacy-policy" target="_blank" class="text-black underline">{{ __('privacy policy') }}</a>.
            </span>

            <div class="col-span-1 custom-toggle justify-self-end">
              <Toggle id="recruit_toggle" :value="values.recruit" @change="handleRecruitStatus" />
            </div>
          </div>
          <div class="grid grid-cols-4 md:grid-cols-4 items-center gap-4">
            <span class="col-span-3"> {{ marketingLabel }} </span>

            <div class="col-span-1 custom-toggle justify-self-end">
              <Toggle id="marketing_toggle" :value="values.marketing" @change="handleMarketingStatus" />
            </div>
          </div>
          <div
            class="mt-8 flex flex-col gap-2 md:flex-row-reverse items-center justify-center"
          >
            <Button
              class="flex items-center justify-center gap-1.5"
              :type="isLoading ? 'button' : 'submit'"
              :disabled="isLoading"
            >
              <Icon
                v-if="isLoading"
                class="animate-spin text-lg"
                name="progress_activity"
              />
              <span>{{ __('Save') }}</span>
            </Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { Toggle } from '../../../../components/global';
  import { SectionHeader } from '@/pages/components/section-header';
  import axios from 'axios';

  const props = defineProps({
    profile: {
      type: Object,
      required: true
    },
    companyName: {
      type: String,
    }
  });

  const toast = useToast();
  const values = ref({
    recruit: props.profile.recruit,
    marketing: props.profile.marketing,
  });
  const errors = ref({ recruit : [] });
  const isLoading = ref(false);

  function handleRecruitStatus() {
    values.value.recruit = !values.value.recruit;
  }

  function handleMarketingStatus() {
    values.value.marketing = !values.value.marketing;
  }

  const marketingLabel = computed(() => {
    const before = __('I would like to receive updates from')
    const after  = __('about career opportunities that match my skills.')
    return `${before} ${props.companyName} ${after}`
  })

  async function handleSubmit() {
    isLoading.value = true;
    try {
      const payload = {
        recruit: !!values.value.recruit,
        marketing: !!values.value.marketing,
      };
      const response = await axios.post(
        route('redesign.candidate.settings.updateGdpr'),
        payload
      );

      if (response?.data?.message && payload.recruit === true) {
        toast.success(response.data.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        errors.value = { ...errors.value, ...error.response.data.errors };
      } else {
        toast.error(
          __('An unexpected error has occurred. Please try again later.')
        );
      }
    }
    isLoading.value = false;
  }
</script>
